import {
  DocumentType,
  NVDRelatedDocumentType,
  NVDRelatedDocumentTypes,
} from "constants/documentTypes";

export function isNVDRelatedDocumentType(
  type: DocumentType | null,
): type is NVDRelatedDocumentType {
  return (
    type !== null &&
    (NVDRelatedDocumentTypes as readonly DocumentType[]).includes(type)
  );
}
